function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState, useMemo } from "react";
import { trackEvent } from "services/bigbrain-service";
import productPricingConfig from "segments/desktop/pricing/product-pricing-config";
import SignupFormComponent from "components/core/signups/base-signup-form/signup-form-component";
import PricesAndFeaturesCardsPricing from "../prices-and-features-cards-pricing/index.js";
import FeatureTablePricing from "../features-table-pricing/index.js";
import { ProductSwitcher } from "./components/product-switcher";
import { PRICING_PAGE_PRODUCT_SWITCHER_CLICKED } from "/constants/bigbrain-event-types";
import { StyledMultiProductsPricingComponent } from "./multi-products-pricing-component.scss";
const MultiProductsPricingComponent = (props)=>{
    const { pricesAndFeaturesCardsPricing, translate } = props;
    const { productName = undefined, isHomepagePricing = false, isApplyMaxDiffFeatures = false, defaultSeatsIndex = 0 } = pricesAndFeaturesCardsPricing;
    const [selectedProductName, setSelectedProductName] = useState(productName);
    const selectedProductColors = useMemo(()=>{
        const { primaryColor, secondaryColor } = productPricingConfig[selectedProductName];
        return {
            primaryColor,
            secondaryColor
        };
    }, [
        selectedProductName
    ]);
    const onProductChange = useCallback((newProductName)=>{
        if (newProductName === selectedProductName) return;
        trackEvent(PRICING_PAGE_PRODUCT_SWITCHER_CLICKED, {
            info1: selectedProductName,
            info2: newProductName,
            productKind: selectedProductName
        });
        setSelectedProductName(newProductName);
    }, [
        selectedProductName
    ]);
    const getSelectedProductId = ()=>{
        const { productId } = productPricingConfig[selectedProductName];
        return productId;
    };
    return /*#__PURE__*/ _jsxs(StyledMultiProductsPricingComponent, {
        className: "multi-products-pricing-component",
        style: {
            "--primary-color": selectedProductColors.primaryColor,
            "--secondary-color": selectedProductColors.secondaryColor
        },
        children: [
            /*#__PURE__*/ _jsx(ProductSwitcher, {
                onProductChange: onProductChange,
                selectedProduct: selectedProductName,
                config: productPricingConfig,
                translate: translate
            }),
            /*#__PURE__*/ _jsx(SignupFormComponent, {
                className: "signup-form",
                ctaText: translate("signup.cta"),
                buttonColor: selectedProductColors.primaryColor,
                buttonSize: "xs",
                useCtaText: true,
                withButtonArrow: true,
                signupProductId: getSelectedProductId(),
                extraData: {
                    productKind: selectedProductName,
                    cta_name: "main_cta"
                }
            }),
            /*#__PURE__*/ _jsx(PricesAndFeaturesCardsPricing.PricesAndFeaturesCardsPricingComponent, _object_spread_props(_object_spread({}, props), {
                productName: selectedProductName,
                isHomepagePricing: isHomepagePricing,
                defaultSeatsIndex: defaultSeatsIndex,
                isApplyMaxDiffFeatures: isApplyMaxDiffFeatures
            })),
            /*#__PURE__*/ _jsx(FeatureTablePricing.FeaturesTablePricingComponent, _object_spread_props(_object_spread({}, props), {
                productName: selectedProductName,
                isHomepagePricing: isHomepagePricing,
                defaultSeatsIndex: defaultSeatsIndex,
                isApplyMaxDiffFeatures: isApplyMaxDiffFeatures
            }))
        ]
    });
};
export default MultiProductsPricingComponent;
